import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useContentBlock = (name: string) => {
  return useQuery({
    queryKey: ["content-block", name],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("content_blocks")
        .select("content")
        .eq("name", name)
        .maybeSingle();
      if (error) throw error;
      return data?.content ?? null;
    },
  });
};

export const STANDARD_DISCLAIMER_KEY = "Standard Legal Disclaimer";